/**
 * This is a reducer for everything related to notifications
 */

import {NotificationActionParams, NotificationActionTypes, NotificationPayload} from "./notification-actions";
import initialState from '../../initialState';

export interface NotificationState {
    data?: NotificationPayload;
    visible: boolean;
}

export default (state = initialState.notification, action?: NotificationActionParams) => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case NotificationActionTypes.SHOW_NOTIFICATION:
            return {
                ...state,
                data: action.payload,
                visible: true,
            };

        case NotificationActionTypes.HIDE_NOTIFICATION:
            return {
                ...state,
                visible: false
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/notification/notification-reducer.ts